import { useTranslation } from "../../localization";
import { joinJSXElements } from "../../utils";
import { useFileExplorerContext } from "./context";
import { flattenItems } from "./shared";

export function FileExplorerFooter() {
	/** Context */
	const { selectedFiles, focusedItem, structure } = useFileExplorerContext();

	/** Hooks */
	const { t } = useTranslation();
	const totalFiles = flattenItems(structure?.items).length;

	const labels = [
		t("files.total_files", { count: `${totalFiles}` }),
		t("files.n_files_selected", { count: `${selectedFiles.length}` }),
		focusedItem
			? t("files.focused_item", {
					name: focusedItem.type === "folder" ? focusedItem.name : focusedItem.file.fileName,
				})
			: null,
	];

	/** Render */
	return (
		<div className="h-8 text-xs">
			<p>{joinJSXElements(labels)}</p>
		</div>
	);
}
